var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({},on),[_c('v-btn',_vm._g({attrs:{"disabled":_vm.disabled,"color":"warning","icon":""}},_vm.$listeners),[_c('v-icon',[_vm._v(" lock ")])],1)],1)]}}])},[_vm._v(" "+_vm._s(("Change password for " + _vm.updatableName))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }